import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import HoldingDiscriminator from 'src/app/shared/enums/HoldingDiscriminator.enum';

@Component({
  selector: 'terra-holding-is-down-card',
  templateUrl: './holding-is-down-card.component.html',
  styleUrls: ['./holding-is-down-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class HoldingIsDownCardComponent implements OnInit {

  @Input() holdingDiscriminator: HoldingDiscriminator;
  @Input() isPrivate: boolean;

  get Holding() {
    return HoldingDiscriminator.toString(this.holdingDiscriminator);
  }

  get holding() {
    return this.Holding.toLowerCase();
  }

  constructor() { }

  ngOnInit() {
  }
}
